import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

/**
 * Generates an `ProgressDots`
 * @param {Object} props - Properties passed to component
 * @returns {ReactElement}
 */

const ProgressDots = ({
    className,
    testSection,
    ...props
}) => {
    return (
        <ul data-oui-component={true} data-test-section={testSection} className={classNames("oui-progress-dots", className)} {...props}>
            <li></li>
            <li></li>
            <li></li>
        </ul>
    );
};

ProgressDots.propTypes = {
    /** CSS class names. */
    className: PropTypes.string,
    /** Hook for automated JavaScript tests */
    testSection: PropTypes.string,
};

ProgressDots.displayName = "ProgressDots";

export default ProgressDots;
